import { api } from '@/lib/api';

/**
 * Téléchargement de fichiers depuis l'API.
 *
 * Le nom de fichier fait autorité côté serveur : les exports y sont horodatés et
 * nommés par jeu de données, ce que le front ne peut pas deviner. Le nom de repli
 * n'est utilisé que si l'en-tête est absent (proxy, réponse en cache, mode hors ligne).
 */

const FILENAME_PATTERN = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i;

export const filenameFromResponse = (response, fallbackName) => {
  const contentDisposition = response?.headers?.['content-disposition'];
  if (contentDisposition) {
    const match = contentDisposition.match(FILENAME_PATTERN);
    if (match?.[1]) {
      try {
        return decodeURIComponent(match[1].trim());
      } catch {
        return match[1].trim();
      }
    }
  }
  return fallbackName;
};

export const downloadBlob = (response, fallbackName, fallbackType) => {
  const contentType =
    response?.headers?.['content-type'] ||
    fallbackType ||
    'application/octet-stream';
  const filename = filenameFromResponse(response, fallbackName);

  const blob = new Blob([response?.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return filename;
};

export const downloadFromApi = async (
  url,
  params = {},
  fallbackName = 'export',
  fallbackType,
) => {
  const response = await api.get(url, { params, responseType: 'blob' });
  return downloadBlob(response, fallbackName, fallbackType);
};

export default downloadBlob;
